import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getPaymentInfo } from '@/redux/actions/payment.action';

const PaymentConfirm: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const checkPaymentStatus = async () => {
      // ЮKassa возвращает payment_id, Т-Касса — PaymentId (плюс Success/ErrorCode).
      const paymentId = searchParams.get('payment_id') || searchParams.get('PaymentId');
      
      if (!paymentId) {
        navigate('/payment-error', {
          state: {
            errorReason: 'Не найден идентификатор платежа',
            errorType: 'error',
            orderId: null,
          },
        });
        return;
      }

      try {
        const paymentInfo = await getPaymentInfo(paymentId);

        if (!paymentInfo) {
          navigate('/payment-error', {
            state: {
              errorReason: 'Не удалось получить информацию о платеже',
              errorType: 'error',
              orderId: null,
            },
          });
          return;
        }

        const status = paymentInfo.status;

        if (status === 'succeeded') {
          navigate('/payment-success');
        } else if (status === 'canceled') {
          navigate('/payment-error', {
            state: {
              errorReason: 'Платеж был отменен',
              errorType: 'cancel',
              orderId: paymentInfo.metadata?.order_id || null,
            },
          });
        } else {
          navigate('/payment-error', {
            state: {
              errorReason: `Статус платежа: ${status}`,
              errorType: 'error',
              orderId: paymentInfo.metadata?.order_id || null,
            },
          });
        }
      } catch (error: any) {
        console.error('Ошибка проверки статуса платежа:', error);
        navigate('/payment-error', {
          state: {
            errorReason: 'Ошибка проверки статуса платежа',
            errorType: 'error',
            orderId: null,
          },
        });
      }
    };

    checkPaymentStatus();
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Обработка платежа...</p>
    </div>
  );
};

export { PaymentConfirm };
